import { render, staticRenderFns } from "./ContractorCollectionFiltersPending.vue?vue&type=template&id=1f2504c6"
import script from "./ContractorCollectionFiltersPending.vue?vue&type=script&lang=ts"
export * from "./ContractorCollectionFiltersPending.vue?vue&type=script&lang=ts"
import style0 from "./ContractorCollectionFiltersPending.vue?vue&type=style&index=0&id=1f2504c6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2504c6')) {
      api.createRecord('1f2504c6', component.options)
    } else {
      api.reload('1f2504c6', component.options)
    }
    module.hot.accept("./ContractorCollectionFiltersPending.vue?vue&type=template&id=1f2504c6", function () {
      api.rerender('1f2504c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorCollectionFiltersPending.vue"
export default component.exports